import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CartRoutingModule } from './cart-routing.module';
import { CartOverviewComponent } from './containers/cart-overview/cart-overview.component';
import { DictionaryNgrxModule } from '@teamfoster/sdk/dictionary-ngrx';

import { CoreModule } from '../core/core.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CartComponent } from './components/cart/cart.component';
import { ShopModule } from '../shop/shop.module';
import { CartSidebarProductLineComponent } from './components/cart-sidebar-product-line/cart-sidebar-product-line.component';
import { InViewModule } from '@teamfoster/sdk/in-view';
import { CartSummaryComponent } from './components/cart-summary/cart-summary.component';
import { DynamicFormModule } from '@teamfoster/dynamic-forms';
import { DiscountFormComponent } from './components/discount-form/discount-form.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CartProductLineComponent } from './components/cart-product-line/cart-product-line.component';
import { TextUtilityModule } from '@teamfoster/sdk/text-utility';
import { RouterModule } from '@angular/router';
import { TaxExemptionAlertComponent } from './components/tax-exemption-alert/tax-exemption-alert.component';

const moduleExports = [CartOverviewComponent, CartComponent, CartSummaryComponent];
@NgModule({
  declarations: [
    ...moduleExports,
    CartSidebarProductLineComponent,
    DiscountFormComponent,
    CartProductLineComponent,
    TaxExemptionAlertComponent,
  ],
  imports: [
    CommonModule,
    CoreModule,
    CartRoutingModule,
    FormsModule,
    ShopModule,
    DictionaryNgrxModule,
    InViewModule,
    DynamicFormModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    TextUtilityModule,
    RouterModule,
  ],
  exports: [...moduleExports],
})
export class CartModule {}
